import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getVehicleList,
  moveVehiclesToCustomer,
  type MoveVehiclesPayload,
  type VehicleListParams,
} from "src/services/vehicleService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

export const useQueryGetVehicleList = (
  params?: VehicleListParams,
  options: { enabled?: boolean } & Record<string, unknown> = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled = !!params?.clientId && options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.vehicleList, params, language],
      queryFn: () => getVehicleList(params as VehicleListParams, language),
      enabled,
      refetchOnMount: true,
      retry: false,
      staleTime:0,
      gcTime: 0,
      ...options,
    }),
    enabled,
  );
};

export const useMutationMoveVehicles = () => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);

  return useMutation({
    mutationFn: (payload: MoveVehiclesPayload) =>
      moveVehiclesToCustomer(payload, language),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: QueryNames.vehicleList }),
        queryClient.invalidateQueries({ queryKey: QueryNames.customerList }),
        queryClient.invalidateQueries({ queryKey: QueryNames.customerStats }),
      ]),
  });
};
